<div class="content-wrapper container-xxl">
    <div class="content-body">
        <div class="card p-0">
            <div class="card-body p-0">
                <loader *ngIf="showLoader"></loader>
                <div class="row mt-20 mb-15 p-md-0 m-md-0">
                    <div class="col-12"> 
                        <swiper class="swiper-container card-list-container" #cardListRef [config]="config" (indexChange)="onIndexChange($event)" fxFlex="auto">
                            <div class="swiper-slide">
                                <div class="single-card exclusive-card">
                                    <!-- <img src="assets/images/smartfx-portal-assets/xplorer-button-2.png" class="exclusive-card-img" /> -->
                                    <img src="assets/images/smartfx-portal-assets/Pulse-1.png" class="exclusive-back-icon" />
                                    <div class="card-img vertical">
                                        <img src="assets/images/smartfx-portal-assets/xplorer_metal_card.png"
                                            class="newcard-img" />
                                    </div>
                                    <div class="card-info">
                                        <div class="newcard-text">Xplorer Card</div>
                                        <div class="newcard-text2">Multi-currency <br>Metal Card</div>
                                        <div class="newcard-text3"><i><!-- Only for Invited Members --> &nbsp;</i></div>
                                        <div class="card-btn">
                                            
                                            <!-- <button class="btn btn-newcard1 btn-prev fs-14" *ngIf="explorerStataData?.registrationStatus == 'NOT_REGISTERED'" (click)="goToExplorerRegister()">
                                                Register Now
                                            </button> -->
                                            <!-- <button class="btn btn-newcard1 btn-prev fs-14" *ngIf="explorerStataData?.buttonToShow == 'VIEW_STATUS'" (click)="viewStatus()">
                                                View Status
                                            </button> -->
                                            <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToActivateXploreCard()" *ngIf="!isXplorerCardAvl">
                                                Buy Card
                                            </button>
                                            <button class="btn btn-newcard1 btn-prev fs-14" (click)="checkXplorerLinkEligibility()" *ngIf="!isXplorerCardAvl">
                                                Link Card
                                            </button>
                                            <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('XPLORER_MULTI_CARD')" *ngIf="isXplorerCardAvl">
                                                Choose Card
                                            </button>
                                        </div>
                                        <div class="newcard-text4" (click)="goToFeatures('XPLORE_CARD')">Know the Features</div>
                                    </div>
                                </div>
                            </div>
                                <div class="swiper-slide"><!--  *ngIf="isSwitchCardVisible == 'true'" -->
                                <!-- <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill> -->
                                    <!-- <div class="col-12"> -->
                                        <div class="single-card">
                                            <div class="card-img vertical">
                                                <img src="assets/images/smartfx-portal-assets/buy-forex/switch_card_front_side_2.png" class="newcard-img" />
                                            </div>
                                            <div class="card-info">
                                                <div class="newcard-text">GlobalPay Smart Switch Card</div>
                                                <div class="newcard-text2">Switch between single to multi-currency</div>
                                                <div class="newcard-text3"><i>Ideal for International Traveller</i></div>
                                                <div class="card-btn">
                                                    <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('GLOBAL_SWITCH_CARD')" *ngIf="!isSwitchCardAvl"> <!-- && !isApplyForCard -->
                                                        Buy Card
                                                    </button>
                                                    <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('GLOBAL_SWITCH_CARD')" *ngIf="!isSwitchCardAvl">
                                                        Link Card
                                                    </button>
                                                    <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('GLOBAL_SWITCH_CARD')" *ngIf="isSwitchCardAvl">
                                                        Choose Card
                                                    </button>
                                                </div>
                                                <div class="newcard-text4" (click)="goToFeatures('GLOBAL_SWITCH_CARD')">Know the Features</div>
                                            </div>
                                        </div>
                                    <!-- </div> -->
                                <!-- </div> -->
                                </div>

                            <div class="swiper-slide">
                            <!-- <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill> -->
                                <!-- <div class="col-12"> -->
                                    <div class="single-card">
                                        <div class="card-img vertical">
                                            <img src="assets/images/smartfx-portal-assets/buy-forex/Updated-UNI-Z-Card.png" class="newcard-img" />
                                        </div>
                                        <div class="card-info">
                                            <div class="newcard-text">UNI-Z Digital Card</div>
                                            <div class="newcard-text2">No paperwork or bank visits,Full control via the GlobalPay App</div>
                                            <div class="newcard-text3"><i>Ideal for Students</i></div>
                                            <div class="card-btn">
                                                <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('UNI_Z_CARD')" *ngIf="!isUniZCardAvl">
                                                    Buy Card
                                                </button>
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('UNI_Z_CARD')" *ngIf="!isUniZCardAvl">
                                                    Link Card
                                                </button>
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('UNI_Z_CARD')" *ngIf="isUniZCardAvl">
                                                    Choose Card
                                                </button>
                                            </div>
                                            <div class="newcard-text4" (click)="goToFeatures('UNI_Z_CARD')">Know the Features</div>
                                        </div>
                                    </div>
                                <!-- </div>                -->
                            <!-- </div> -->
                            </div>
                            <div class="swiper-slide">
                            <!-- <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill> -->
                                <!-- <div class="col-12"> -->
                                    <div class="single-card">
                                        <div class="card-img vertical">
                                            <img src="assets/images/smartfx-portal-assets/buy-forex/Global-Multi-Currency-Card-Front-horizontal.png" class="newcard-img" />
                                        </div>
                                        <div class="card-info">
                                            <div class="newcard-text">GlobalPay Multi-Currency Card</div>
                                            <div class="newcard-text2">Multi-currency Card</div>
                                            <div class="newcard-text3"><i>Ideal for International Travelers</i></div>
                                            <div class="card-btn">
                                                <!-- <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('GLOBAL_MULTI_CARD')" *ngIf="!isGlobalPayMultiAvl">
                                                    Buy Card
                                                </button> -->
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('GLOBAL_MULTI_CARD')" *ngIf="!isGlobalPayMultiAvl">
                                                    Link Card
                                                </button>
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('GLOBAL_MULTI_CARD')" *ngIf="isGlobalPayMultiAvl">
                                                    Choose Card
                                                </button>
                                            </div>
                                            <div class="newcard-text4" (click)="goToFeatures('GLOBAL_MULTI_CARD')">Know the Features</div>
                                        </div>
                                    </div>
                                <!-- </div> -->
                            <!-- </div> -->
                            </div>
                            <div class="swiper-slide">
                            <!-- <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill> -->
                                <!-- <div class="col-12"> -->
                                    <div class="single-card">
                                        <div class="card-img vertical">
                                            <img src="assets/images/smartfx-portal-assets/buy-forex/wsfx-global-pay-card-horizontal.png" class="newcard-img" />
                                        </div>
                                        <div class="card-info">
                                            <div class="newcard-text">Global Pay Card</div>
                                            <div class="newcard-text2">US Dollar Card with Zero Cross Currency Fee</div>
                                            <div class="newcard-text3"><i>Ideal for Business Travellers</i></div>
                                            <div class="card-btn">
                                                <!-- <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('GLOBAL_CARD')" *ngIf="!isGlobalPayAvl">
                                                    Buy Card
                                                </button> -->
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('GLOBAL_CARD')" *ngIf="!isGlobalPayAvl">
                                                    Link Card
                                                </button>
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('GLOBAL_CARD')" *ngIf="isGlobalPayAvl">
                                                    Choose Card
                                                </button>
                                            </div>
                                            <div class="newcard-text4" (click)="goToFeatures('GLOBAL_CARD')">Know the Features</div>
                                        </div>
                                    </div>
                                <!-- </div>                -->
                            <!-- </div> -->
                            </div>


                            <div class="swiper-slide">
                            <!-- <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill> -->
                                <!-- <div class="col-12"> -->
                                    <div class="single-card">
                                        <div class="card-img vertical">
                                            <img src="assets/images/smartfx-portal-assets/buy-forex/wsfx-student-pay-card-horizontal.png" class="newcard-img" />
                                        </div>
                                        <div class="card-info">
                                            <div class="newcard-text">Student Pay Card</div>
                                            <div class="newcard-text2">US Dollar Card with Zero Cross Currency Fee</div>
                                            <div class="newcard-text3"><i>Ideal for Students</i></div>
                                            <div class="card-btn">
                                                <!-- <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('STUDENT_CARD')" *ngIf="!isStudentPayAvl">
                                                    Buy Card
                                                </button> --> <!-- && !isApplyForCard -->
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('STUDENT_CARD')" *ngIf="!isStudentPayAvl">
                                                    Link Card
                                                </button>
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('STUDENT_CARD')" *ngIf="isStudentPayAvl">
                                                    Choose Card
                                                </button>
                                            </div>
                                            <div class="newcard-text4" (click)="goToFeatures('STUDENT_CARD')">Know the Features</div>
                                        </div>
                                    </div>
                                <!-- </div> -->

                            <!-- </div> -->

                            </div>
                            <div class="swiper-slide">
                                <div class="single-card">
                                    <div class="card-img vertical">
                                        <img src="assets/images/smartfx-portal-assets/buy-forex/wsfx-travel-pay-card-horizontal.png" class="newcard-img" />
                                    </div>
                                    <div class="card-info">
                                        <div class="newcard-text">Travel Pay Card</div>
                                        <div class="newcard-text2">US Dollar Card with Zero Cross Currency Fee</div>
                                        <div class="newcard-text3"><i>Ideal for International Travellers</i></div>
                                            <div class="card-btn">
                                                <!-- <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('TRAVEL_CARD')" *ngIf="!isTravelPayAvl">
                                                    Buy Card
                                                </button> -->
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('TRAVEL_CARD')"
                                                    *ngIf="!isTravelPayAvl">
                                                    Link Card
                                                </button>
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('TRAVEL_CARD')" *ngIf="isTravelPayAvl">
                                                    Choose Card
                                                </button>
                                            </div>
                                        <div class="newcard-text4" (click)="goToFeatures('TRAVEL_CARD')">Know the Features</div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="swiper-slide">
                                    <div class="single-card">
                                        <div class="card-img vertical">
                                            <img src="assets/images/smartfx-portal-assets/buy-forex/smart-currency-card-horizontal.png" class="newcard-img">
                                        </div>
                                        <div class="card-info">
                                            <div class="newcard-text">Smart Currency Card</div>
                                            <div class="newcard-text2">Multicurrency Card with <br> INR Wallet</div>
                                            <div class="newcard-text3"><i>Ideal for International Travellers</i></div>
                                            <div class="card-btn">
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="smartCardDisabledPopup()" *ngIf="!isSmartCardAvl">
                                                    Link Card
                                                </button>
                                                <button class="btn btn-newcard1 btn-prev fs-14" (click)="smartCardDisabledPopup()" *ngIf="isSmartCardAvl">
                                                    Choose Card
                                                </button>
                                            </div>
                                            <div class="newcard-text4" style="visibility: hidden;">Know the Features</div>
                                        </div>
                                    </div>
                            </div> -->
                        </swiper>
                

                    </div>



                    <!-- && !isApplyForCard -->
                    <!--  && !isApplyForCard -->
                    <!-- <div class="col-4">




                        <swiper-container loop="true">
                            <swiper-slide>
                                <div class="">
                                    <div class="newcard-border dash-newcard1">
                                    <img src="assets/images/smartfx-portal-assets/buy-forex/student-pay-card.png" class="newcard-img">
                                    <div class="newcard-text">Student Pay Card</div>
                                    <div class="newcard-text2">US Dollar Card with Zero Cross Currency Fee</div>
                                    <div class="newcard-text3"><i>Ideal for Students</i></div>
                                    <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('studentPayCard')" *ngIf="!isStudentPayAvl"> 
                                        Buy Card
                                    </button>
                                    <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('studentPayCard')" *ngIf="!isStudentPayAvl">
                                        Link Card
                                    </button>
                                    <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('studentPayCard')" *ngIf="isStudentPayAvl">
                                        Choose Card
                                    </button>
                                    <div class="newcard-text4" (click)="goToFeatures('studentPayCard')">Know the Features</div>
                                    </div>
                                </div>                            
                            </swiper-slide>
                            <swiper-slide>
                                <div class="">
                                    <div class="newcard-border dash-newcard1">
                                    <img src="assets/images/smartfx-portal-assets/buy-forex/wsfx-travel-pay-card.png" class="newcard-img">
                                    <div class="newcard-text">Travel Pay Card</div>
                                    <div class="newcard-text2">US Dollar Card with Zero Cross Currency Fee</div>
                                    <div class="newcard-text3"><i>Ideal for International Travellers</i></div>
                                    <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('travelPayCard')" *ngIf="!isTravelPayAvl"> 
                                        Buy Card
                                    </button>
                                    <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('travelPayCard')" *ngIf="!isTravelPayAvl">
                                        Link Card
                                    </button>
                                    <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('travelPayCard')" *ngIf="isTravelPayAvl">
                                        Choose Card
                                    </button>
                                    <div class="newcard-text4" (click)="goToFeatures('travelPayCard')">Know the Features</div>
                                    </div>
                                </div>                        
                            </swiper-slide>
                            <swiper-slide>
                                <div class="">
                                    <div class="newcard-border dash-newcard1">
                                    <img src="assets/images/smartfx-portal-assets/buy-forex/wsfx-global-pay-card.png" class="newcard-img">
                                    <div class="newcard-text">Global Pay Card</div>
                                    <div class="newcard-text2">US Dollar Card with Zero Cross Currency Fee</div>
                                    <div class="newcard-text3"><i>Ideal for Business Travellers</i></div>
                                    <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('globalPayCard')" *ngIf="!isGlobalPayAvl">
                                        Link Card
                                    </button>
                                    <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('globalPayCard')" *ngIf="isGlobalPayAvl">
                                        Choose Card
                                    </button>
                                    <div class="newcard-text4" (click)="goToFeatures('globalPayCard')">Know the Features</div>
                                    </div>
                                </div>                        
                            </swiper-slide>
                            <swiper-slide>
                                <div class="">
                                    <div class="newcard-border dash-newcard1">
                                    <img src="assets/images/smartfx-portal-assets/buy-forex/card.png" class="newcard-img">
                                    <div class="newcard-text">Smart Currency Card</div>
                                    <div class="newcard-text2">Multicurrency Card with INR Wallet</div>
                                    <div class="newcard-text3"><i>Ideal for International Travellers</i></div>
                                    <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('smartCurrencyCard')" *ngIf="!isSmartCardAvl"> 
                                        Buy Card
                                    </button>
                                    <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('smartCurrencyCard')" *ngIf="!isSmartCardAvl">
                                        Link Card
                                    </button>
                                    <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('smartCurrencyCard')" *ngIf="isSmartCardAvl">
                                        Choose Card
                                    </button>
                                    <div class="newcard-text4" (click)="goToFeatures('smartCurrencyCard')">Know the Features</div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper-container>
                    </div> -->
                </div>
            </div>
        </div>
<!-- && !isApplyForCard -->
<!-- && !isApplyForCard -->
        
        <!-- <div class="row mt-30">
            <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12 col-xs-12 card-order">
                <div class="col-md-7">
                    <div class="col-md-9 mt-20">
                        <section class="card-section">
                            <div class="row">
                                <div class="swipe-container">

                                    <div class="">
                                        <div class="newcard-border dash-newcard1">
                                        <img src="assets/images/smartfx-portal-assets/buy-forex/student-pay-card.png" class="newcard-img">
                                        <div class="newcard-text">Student Pay Card</div>
                                        <div class="newcard-text2">US Dollar Card with Zero Cross Currency Fee</div>
                                        <div class="newcard-text3"><i>Ideal for Students</i></div>
                                        <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('studentPayCard')" *ngIf="!isStudentPayAvl"> 
                                            Buy Card
                                        </button>
                                        <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('studentPayCard')" *ngIf="!isStudentPayAvl">
                                            Link Card
                                        </button>
                                        <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('studentPayCard')" *ngIf="isStudentPayAvl">
                                            Choose Card
                                        </button>
                                        <div class="newcard-text4" (click)="goToFeatures('studentPayCard')">Know the Features</div>
                                        </div>
                                    </div>                                    


                                    <div class="">
                                        <div class="newcard-border dash-newcard1">
                                        <img src="assets/images/smartfx-portal-assets/buy-forex/wsfx-travel-pay-card.png" class="newcard-img">
                                        <div class="newcard-text">Travel Pay Card</div>
                                        <div class="newcard-text2">US Dollar Card with Zero Cross Currency Fee</div>
                                        <div class="newcard-text3"><i>Ideal for International Travellers</i></div>
                                        <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('travelPayCard')" *ngIf="!isTravelPayAvl"> 
                                            Buy Card
                                        </button>
                                        <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('travelPayCard')" *ngIf="!isTravelPayAvl">
                                            Link Card
                                        </button>
                                        <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('travelPayCard')" *ngIf="isTravelPayAvl">
                                            Choose Card
                                        </button>
                                        <div class="newcard-text4" (click)="goToFeatures('travelPayCard')">Know the Features</div>
                                        </div>
                                    </div>


                                    <div class="">
                                        <div class="newcard-border dash-newcard1">
                                        <img src="assets/images/smartfx-portal-assets/buy-forex/wsfx-global-pay-card.png" class="newcard-img">
                                        <div class="newcard-text">Global Pay Card</div>
                                        <div class="newcard-text2">US Dollar Card with Zero Cross Currency Fee</div>
                                        <div class="newcard-text3"><i>Ideal for Business Travellers</i></div>
                                        <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('globalPayCard')" *ngIf="!isGlobalPayAvl">
                                            Link Card
                                        </button>
                                        <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('globalPayCard')" *ngIf="isGlobalPayAvl">
                                            Choose Card
                                        </button>
                                        <div class="newcard-text4" (click)="goToFeatures('globalPayCard')">Know the Features</div>
                                        </div>
                                    </div>

                                    <div class="">
                                        <div class="newcard-border dash-newcard1">
                                        <img src="assets/images/smartfx-portal-assets/buy-forex/card.png" class="newcard-img">
                                        <div class="newcard-text">Smart Currency Card</div>
                                        <div class="newcard-text2">Multicurrency Card with INR Wallet</div>
                                        <div class="newcard-text3"><i>Ideal for International Travellers</i></div>
                                        <button class="btn btn-newcard btn-prev fs-14" (click)="cardBuy('smartCurrencyCard')" *ngIf="!isSmartCardAvl"> 
                                            Buy Card
                                        </button>
                                        <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToLinkExistingCard('smartCurrencyCard')" *ngIf="!isSmartCardAvl">
                                            Link Card
                                        </button>
                                        <button class="btn btn-newcard1 btn-prev fs-14" (click)="goToMyCard('smartCurrencyCard')" *ngIf="isSmartCardAvl">
                                            Choose Card
                                        </button>
                                        <div class="newcard-text4" (click)="goToFeatures('smartCurrencyCard')">Know the Features</div>
                                        </div>
                                    </div>
                            
                                </div>
                            </div>
                          </section>
                    </div>
                </div>
            </div>
        </div> -->
        

       
    
        <!-- <hr class="dotted"> -->

       <!-- <div class="d-flex justify-content-between mt-20">
            <button type="button" class="btn btn-primary btn-back fs-12" rippleEffect (click)="backClick()">
                    <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                    <span class="align-middle">Back</span>
                </button>
            <button type="submit" class="btn btn-primary btn-next fs-12 web-currency-buy-order-started" (click)="checkVcip()" rippleEffect>
                    <span class="align-middle">Next</span>
                    <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                </button>
        </div>-->
    </div>
</div>
<ng-template let-modal #cardRegistrationIn>
    <div class="modal-header">
        <h6 class="modal-title w-100 text-center fw-bold card-activation-success" style="color: #000;" id="myModalLabel1"><b>You're Already In</b></h6>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="row">
            <div class="col-12">
                <div class="card-activate-img text-center">
                    <img src="assets/images/smartfx-portal-assets/success.gif" style="width: 80px;" />
                </div>
            </div>
            <div class="col-12">
                <p class="text-center">You've secured your spot on the Xplorer waitlist. Check your email for confirmation and exclusive updates.</p>
            </div>
        </div>

    </div>
</ng-template>

<!-- xplorer popup -->
 <ng-template let-modal #vcipModalNewUser>
    <div class="modal-header" *ngIf="xplorerVcipTitle">
        <h6 class="modal-title w-100 text-center fw-bold" style="color: #1d2a62;">{{ xplorerVcipTitle }}</h6>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="col-md-12">
            <div class="text-center text-black fw-500 mt-10 mb-10 fs-14" style="color: black">
                {{ xplorerVcipMessage || 'VCIP (Video KYC in Person) is mandatory and must be completed at the verified address before your travel. Completing this early ensures smooth usage of your card abroad.' }}
            </div>
        </div>
    </div>
    <div class="modal-footer" *ngIf="shouldShowVcipActionButton()">
        <div class="row w-100 justify-content-center">
            <button class="btn vcip-btn vcip-okay-btn" rippleEffect (click)="initiateVcip()">
                {{ getXplorerVcipActionLabel() }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template let-modal #PANDetailModal>
        <div class="modal-header" style="display:block; ">
            <h5 class="modal-title fw-600" id="myModalLabel1" style="text-align:center; color: #1d2a62;">Costumer Details</h5>
        </div>
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <label class="form-label mb-5"><b>Permanent Account Number (PAN)*</b></label>
            <input required type="text" name="panNo" (keypress)="alphaNumberOnly($event)" (input)="getPanName()" class="form-control fs-12" style="border-color:black" placeholder="Enter your PAN"  maxlength="10" (paste)="onPaste($event)" [(ngModel)]="updateProfileModel.pan" required minlength="10" />
        </div>
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <label class="form-label mb-5"><b>Name as per Permanent Account Number*</b></label>
            <input required type="text" name="panName" class="form-control fs-12" style="border-color:black" placeholder="Name as per PAN"   (paste)="onPaste($event)" [(ngModel)]="updateProfileModel.name" required/>
        </div>
        <div class="modal-body">
        <div class="custom-control custom-checkbox col-md-12 fs-12">
            <input type="checkbox" [(ngModel)]="isPANCBChecked" id="checkboxForAcceptTermsAndCondition" class="custom-control-input"  style="border-top:  1.2px dashed rgb(138 144 150 / 75%) !important">
            <label class="custom-control-label text-black fs-11" for="checkboxForAcceptTermsAndCondition">  I declare that the PAN provided belongs to me.</label>
        </div>
        </div>
        <div class="modal-body">
            <label class="form-label"><b>Date Of Birth*</b></label>
            <div class="input-group">
                <input class="form-control fs-12" (click)="basicDP.toggle()" name="dob" style="border-color:black" placeholder="Select Date of Birth" [maxDate]="dobMaxDate" [(ngModel)]="updateProfileModel.dob" ngbDatepicker #basicDP="ngbDatepicker" required [minDate]="{year: 1900, month: 1, day: 1}"
                   >
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary icomoon icon-calendar_date_day_event_month_icon" (click)="basicDP.toggle()" type="button" rippleEffect></button>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            
            <button class="col-md-12  mt-10 btn btn-primary fs-10"  rippleEffect (click)="validatePanAPI()">
            Proceed
        </button>
        </div>
</ng-template>


<ng-template #errorModal let-modal>
    <div class="modal-header">
        <div class="modal-title fs-10 text-black text-center" id="myModalLabel1">

        </div>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="text-center red-text-delete">Invalid Details
        </div>
        <div class="text-center">
            {{panVerificationErrMsg}}        
        </div>
    </div>
    
    <div class="col-md-12  text-center">
        <div class="mb-10 fw-500 fs-10 btn btn-primary" (click)="modal.dismiss('Cross click')"
            style="cursor: pointer;">
            Close
        </div>
    </div>
</ng-template>